import { useEffect } from 'react';

import { emitter } from '../../util/emitter';

export const useOnWidgetExpanded = (
  callback: (expanded: boolean) => void,
): void => {
  useEffect(() => {
    emitter.on('widgetExpanded', callback);
    return () => emitter.removeListener('widgetExpanded', callback);
  }, [callback]);
};
